import { t } from 'i18next';
import * as yup from 'yup';

export const getUsageLimitsSchema = () =>
  yup.object().shape({
    limit: yup
      .string()
      .test('integer', t('validation.integer_required'), (v) => !v || Number.isInteger(Number(v)))
      .test('min-value', t('validation.min_value', { 0: 0 }), (v) => !v || Number(v) >= 0),
    percentages: yup
      .array()
      .of(yup.string())
      .when('limit', {
        is: (val: string) => !!val,
        then: (schema) => schema.min(1, t('errors.select_at_least_one')),
      }),
    emails: yup
      .array()
      .of(yup.object().shape({ value: yup.string().email(t('errors.invalid_email')) }))
      .when('limit', {
        is: (val: string) => !!val,
        then: (schema) =>
          schema.test(
            'at-least-one-email',
            t('validation.required'),
            (emails) => emails?.some((e) => !!e?.value) ?? false
          ),
      }),
  });
